import { render, staticRenderFns } from "./ModalMemo.vue?vue&type=template&id=259c36ac&scoped=true&"
import script from "./ModalMemo.vue?vue&type=script&lang=js&"
export * from "./ModalMemo.vue?vue&type=script&lang=js&"
import style0 from "./ModalMemo.vue?vue&type=style&index=0&id=259c36ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c36ac",
  null
  
)

export default component.exports